<div class="dropdown-container">  
  <div class="dropdown-button" [ngClass]="{'no-border': noBorder}" [matTooltip]="iconTitle" (click)="changeValue()">
    <img class="svg-icon" src="../../../../assets/svgs/{{icon}}.svg" alt="icon-action">
  </div>

  <div class="dropdown-box" [ngClass]="{'align-right': alignRight}" *ngIf="isOpen">
    <ng-content></ng-content>
  </div>
</div>
